import * as React from 'react'
import { pipe, RD, T, TE } from '@packages/prelude'
import * as domain from '@packages/domain'
import { ApiContext } from './Context'

export const useApi = <P, A>(
  endpoint: domain.Api.Endpoint.Type<P, A>
): [(params: P) => TE.TaskEither<domain.Error.Type, A>, RD.RemoteData<domain.Error.Type, A>, () => void] => {
  const deps = React.useContext(ApiContext)
  const [request, setRequest] = React.useState<RD.RemoteData<domain.Error.Type, A>>(RD.initial)

  const query = React.useCallback(
    (params: P): TE.TaskEither<domain.Error.Type, A> =>
      pipe(
        deps,
        TE.fromOption(() => domain.Error.fromString('ApiProvider missing')),
        TE.chainFirstIOK(() => () => setRequest(RD.pending)),
        TE.chain(d => endpoint(params)(d)),
        T.chainFirstIOK(response => () => pipe(response, RD.fromEither, setRequest))
      ),
    [deps, endpoint]
  )

  const reset = React.useCallback(() => setRequest(RD.initial), [])

  return [query, request, reset]
}
